import styled from "styled-components";
import { viewSizes } from "./variables";

export const NavWrapper = styled.nav`
  padding: 6rem;
  display: flex;
  align-items: center;

  @media only screen and (max-width: ${viewSizes.mobile}) {
    flex-direction: column;
    justify-content: center;
  }

  & > img {
    margin-right: 3rem;
    cursor: pointer;

    @media only screen and (max-width: ${viewSizes.mobile}) {
      margin-right: unset;
      margin-bottom: 2rem;
    }
  }

  & > div > a {
    color: white;
    font-size: 2.2rem;
    font-family: "SpoqaHanSansNeo-Medium", "SpoqaHanSansNeo-Regular";
    margin-right: 3rem;
  }

  & > div > a:last-of-type {
    margin-right: unset;
  }
`;
